import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ClienttemplateComponent } from './clienttemplate.component';

const routes: Routes = [ { path: '', component: ClienttemplateComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class clienttemplateRoutingModule { }
